import {Injectable} from '@angular/core';

@Injectable()
export class TyreValuesService {
	readonly SIDE_DX = 'destro';
	readonly SIDE_SX = 'sinistro';
	readonly SIDE_CN = 'centrale';

	readonly POSITION_INT = 'interno';
	readonly POSITION_EXT = 'esterno';

	readonly AXIS_1 = '1';
	readonly AXIS_2 = '2';

	readonly twoWheels = [
		{axis: this.AXIS_2, side: this.SIDE_CN, position: this.POSITION_EXT},
		{axis: this.AXIS_1, side: this.SIDE_CN, position: this.POSITION_EXT}
	];

	readonly threeWheels = [
		{axis: this.AXIS_2, side: this.SIDE_CN, position: this.POSITION_EXT},
		{axis: this.AXIS_1, side: this.SIDE_SX, position: this.POSITION_EXT},
		{axis: this.AXIS_1, side: this.SIDE_DX, position: this.POSITION_EXT}
	];

	readonly fourWheels = [
		{axis: this.AXIS_2, side: this.SIDE_SX, position: this.POSITION_EXT},
		{axis: this.AXIS_1, side: this.SIDE_SX, position: this.POSITION_EXT},
		{axis: this.AXIS_1, side: this.SIDE_DX, position: this.POSITION_EXT},
		{axis: this.AXIS_2, side: this.SIDE_DX, position: this.POSITION_EXT}
	];

	readonly sixWheels = [
		{axis: this.AXIS_2, side: this.SIDE_SX, position: this.POSITION_EXT},
		{axis: this.AXIS_1, side: this.SIDE_SX, position: this.POSITION_EXT},
		{axis: this.AXIS_1, side: this.SIDE_DX, position: this.POSITION_EXT},
		{axis: this.AXIS_2, side: this.SIDE_SX, position: this.POSITION_INT},
		{axis: this.AXIS_2, side: this.SIDE_DX, position: this.POSITION_INT},
		{axis: this.AXIS_2, side: this.SIDE_DX, position: this.POSITION_EXT}
	];

	readonly brand_list = [
		'BARUM',
		'BF-GOODRICH',
		'BRIDGESTONE',
		'CONTINENTAL',
		'DUNLOP',
		'FIRESTONE',
		'FORMULA',
		'FULDA',
		'GOODYEAR',
		'GT-RADIAL',
		'HANKOOK',
		'KLEBER',
		'KUMHO',
		'MATODOR',
		'MICHELIN',
		'NOKIAN',
		'PIRELLI',
		'SAVA',
		'SEMPERIT',
		'SPORTIVA',
		'TOYO',
		'UNIROYAL',
		'YOKOHAMA'
	];

	readonly damage_list = [
        {value: 'NESSUNO'},
        {value: 'NON CONFORME'},
        {value: 'USURATO'},
		{value: 'TAGLIO'},
		{value: 'ERNIA'},
		{value: 'STRAPPO'},
		{value: 'TAGLIO/STRAPPO'},
		{value: 'TAGLIO/ERNIA'},
		{value: 'ERNIA/STRAPPO'}
	];

	readonly season_list = [
		{value: 'Estivo'},
		{value: 'Invernale'},
		{value: 'm+s'}
	];
	readonly types_deposit = [
		{value: 'NESSUNA', labels: {it: 'Nessuno'}},
		{value: 'CENTRO', labels: {it: 'Centro consegna-gommista'}},
		{value: 'CLIENTE', labels: {it: 'Presso cliente'}}
	];

	readonly speed_rating_list = [
		{value: 'G'}, {value: 'J'}, {value: 'K'}, {value: 'L'}, {value: 'M'}, {value: 'N'}, {value: 'P'}, {value: 'Q'},
		{value: 'R'}, {value: 'S'}, {value: 'T'}, {value: 'H'}, {value: 'V'}, {value: 'W'}, {value: 'Y'}, {value: 'Z'}
	];

	readonly ratio_list = [
		{value: '13'}, {value: '25'}, {value: '30'}, {value: '35'}, {value: '40'}, {value: '45'}, {value: '50'}, {value: '55'},
		{value: '60'}, {value: '65'}, {value: '67'}, {value: '69'}, {value: '70'}, {value: '75'}, {value: '80'},
		{value: '85'}, {value: '90'}, {value: '100'}
	];

	readonly width_list = [
		{value: '60'}, {value: '70'}, {value: '80'}, {value: '90'}, {value: '100'}, {value: '105'}, {value: '110'},
		{value: '115'}, {value: '120'}, {value: '125'}, {value: '130'}, {value: '135'}, {value: '140'}, {value: '145'},
		{value: '150'}, {value: '155'}, {value: '160'}, {value: '165'}, {value: '170'}, {value: '175'}, {value: '180'},
		{value: '185'}, {value: '190'}, {value: '195'}, {value: '200'}, {value: '205'}, {value: '210'}, {value: '215'},
		{value: '225'}, {value: '235'}, {value: '240'}, {value: '245'}, {value: '250'}, {value: '255'}, {value: '265'},
		{value: '270'}, {value: '275'}, {value: '280'}, {value: '285'}, {value: '295'}, {value: '300'}, {value: '305'},
		{value: '315'}, {value: '325'}, {value: '330'}, {value: '335'}, {value: '345'}, {value: '355'}, {value: '7,5'}
	];

	readonly diameter_list = [
		{value: '12'}, {value: '13'}, {value: '14'}, {value: '15'}, {value: '16'}, {value: '17'}, {value: '18'},
		{value: '19'}, {value: '20'}, {value: '21'}, {value: '22'}, {value: '23'}, {value: '24'}, {value: '25'}
	];
	readonly dot_week_list: any[] = [];
	readonly dot_year_list: any[] = [];

	readonly type_list = [
		{value: 'STD', labels: {it: 'Standard'}},
		{value: 'SEAL', labels: {it: 'Autosigillanti'}},
		{value: 'RF', labels: {it: 'Runflat'}}
	];

	constructor() {
		const countWeek = 53;
		for (let i = 1; i <= countWeek; i++) {
			const l = i < 10 ? '0' + i : i.toString();
			this.dot_week_list.push({value: i, labels: {it: l}});
		}
		const yearNow = new Date().getFullYear();
		let currentYear: string;
		for (let i = yearNow - 2013; i >= 0; i--) {
			currentYear = (yearNow - i) + '';
			const value = currentYear.substring(currentYear.length - 2);
			this.dot_year_list.push({value: +value, labels: {it: value}});
		}
	}
}
